import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Lock, ArrowRight } from 'lucide-react';
export const Login = () => {
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    // Mock login - redirect to buyer dashboard
    navigate('/dashboard/buyer');
  };
  return <div className="min-h-screen flex" data-id="element-1036">
      {/* Left: Image */}
      <div className="hidden lg:block lg:w-1/2 relative" data-id="element-1037">
        <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80&w=1000" alt="Luxury Real Estate" className="w-full h-full object-cover" data-id="element-1038" />
        <div className="absolute inset-0 bg-primary-900/40" data-id="element-1039" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-900 to-transparent" data-id="element-1040" />

        <div className="absolute bottom-12 left-12 right-12 text-white" data-id="element-1041">
          <Link to="/" className="flex items-center gap-2 mb-8" data-id="element-1042">
            <div className="w-10 h-10 rounded bg-secondary flex items-center justify-center font-serif font-bold text-2xl text-primary-900" data-id="element-1043">
              A
            </div>
            <span className="font-serif font-bold text-3xl tracking-tight" data-id="element-1044">
              AMU
            </span>
          </Link>
          <h2 className="text-4xl font-serif font-bold mb-4" data-id="element-1045">Welcome Back</h2>
          <p className="text-lg text-white/80 max-w-md" data-id="element-1046">
            Access your verified real estate portfolio and continue your journey
            in Abuja's premium property market.
          </p>
        </div>
      </div>

      {/* Right: Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-white" data-id="element-1047">
        <div className="w-full max-w-md" data-id="element-1048">
          {/* Mobile Logo */}
          <Link to="/" className="flex lg:hidden items-center gap-2 mb-12 justify-center" data-id="element-1049">
            <div className="w-10 h-10 rounded bg-primary-900 flex items-center justify-center font-serif font-bold text-2xl text-secondary" data-id="element-1050">
              A
            </div>
            <span className="font-serif font-bold text-3xl tracking-tight text-primary-900" data-id="element-1051">
              AMU
            </span>
          </Link>

          <div className="mb-10 text-center lg:text-left" data-id="element-1052">
            <h1 className="text-3xl font-serif font-bold text-primary-900 mb-2" data-id="element-1053">
              Sign In
            </h1>
            <p className="text-text-light" data-id="element-1054">
              Enter your credentials to access your account.
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6" data-id="element-1055">
            <div data-id="element-1056">
              <label className="block text-sm font-bold text-text mb-2" data-id="element-1057">
                Email Address
              </label>
              <div className="relative" data-id="element-1058">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-neutral-dark" size={20} data-id="element-1059" />
                <input type="email" placeholder="name@example.com" className="w-full pl-12 pr-4 py-3.5 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 focus:border-primary-900 outline-none transition-all" required data-id="element-1060" />
              </div>
            </div>

            <div data-id="element-1061">
              <div className="flex items-center justify-between mb-2" data-id="element-1062">
                <label className="block text-sm font-bold text-text" data-id="element-1063">
                  Password
                </label>
                <a href="#" className="text-sm font-medium text-secondary hover:text-secondary-dark" data-id="element-1064">
                  Forgot Password?
                </a>
              </div>
              <div className="relative" data-id="element-1065">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-neutral-dark" size={20} data-id="element-1066" />
                <input type="password" placeholder="••••••••" className="w-full pl-12 pr-4 py-3.5 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 focus:border-primary-900 outline-none transition-all" required data-id="element-1067" />
              </div>
            </div>

            <div className="flex items-center" data-id="element-1068">
              <input type="checkbox" id="remember" className="rounded text-primary-900 focus:ring-primary-900 w-4 h-4" data-id="element-1069" />
              <label htmlFor="remember" className="ml-2 text-sm text-text-light" data-id="element-1070">
                Remember me for 30 days
              </label>
            </div>

            <button type="submit" className="w-full bg-primary-900 hover:bg-primary-800 text-white py-4 rounded-xl font-bold transition-colors flex items-center justify-center gap-2 shadow-lg" data-id="element-1071">
              Sign In <ArrowRight size={18} data-id="element-1072" />
            </button>

            <div className="relative py-4" data-id="element-1073">
              <div className="absolute inset-0 flex items-center" data-id="element-1074">
                <div className="w-full border-t border-neutral-200" data-id="element-1075"></div>
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-1076">
                <span className="px-4 bg-white text-text-light" data-id="element-1077">
                  Or continue with
                </span>
              </div>
            </div>

            <button type="button" className="w-full bg-white border border-neutral-200 hover:bg-neutral-50 text-text py-3.5 rounded-xl font-bold transition-colors flex items-center justify-center gap-3" data-id="element-1078">
              <svg className="w-5 h-5" viewBox="0 0 24 24" data-id="element-1079">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-1080" />
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-1081" />
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-1082" />
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-1083" />
              </svg>
              Google
            </button>
          </form>

          <p className="mt-8 text-center text-sm text-text-light" data-id="element-1084">
            Don't have an account?{' '}
            <Link to="/register" className="font-bold text-primary-900 hover:text-secondary transition-colors" data-id="element-1085">
              Create an account
            </Link>
          </p>
        </div>
      </div>
    </div>;
};